import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const widgetApiSlice = createSlice({
  name: 'widgetApi',
  initialState,
  reducers: {
    setWidgetApiModalData: (state, action) => {
      return {
        ...state,
        ...action.payload,
        showWidgetApiInitialState: true,
      };
    },
    /*eslint array-callback-return: */
    updateWidgetApiState(state, action) {
      const keys = Object.keys(action.payload);
      keys.map(key => {
        if (key === 'WidgetApi') {
          state.showWidgetApiInitialState = false;
          state[key] = action.payload[key];
        } else {
          state[key] = action.payload[key];
        }
      });
    },
    setWidgetApiIsLoading(state, action) {
      state.isloading = action?.payload?.isloading;
    },
    
    reset:()=>initialState,
      
    
  },
});

const { reducer, actions } = widgetApiSlice;

export const { setWidgetApiModalData, updateWidgetApiState,reset } = actions;
export default reducer;
